export default "__VITE_ASSET__DLi3zWDJ__"